<template>
  <div class="home-image">
    <b-container class="mw-100">
      <b-row>
        <b-col sm="12" md="2" lg="8" xl="8"/>

        <b-col sm="12" md="8" lg="4" xl="4">
          <b-card class="t-50 mt-3">
            <div class="mt-2">
              <font-awesome-icon icon="user" class="c-green mb-1 mr-2"/>
              <h4 class="c-green mb-0 d-inline">{{$tc('message.user', 1)}}:</h4>
              <div class="ml-4">{{user.userName}}</div>
            </div>

            <div class="mt-3">
              <font-awesome-icon icon="user-tag" class="c-green mb-1 mr-1"/>
              <h4 class="c-green mb-0 d-inline">{{$tc('message.role', 1)}}:</h4>
              <div class="ml-4">{{isDefaultAdmin ? $tc('message.adminDefault', 1) : user.config && user.config.role}}</div>
            </div>

            <div class="mt-3">
              <font-awesome-icon icon="mouse-pointer" class="c-green mb-1 ml-1"/>
              <h4 class="c-green mb-0 d-inline ml-2">{{$tc('message.lastFunction', 2)}}:</h4>
            </div>

            <div v-for="(log, index) in items" :key="index" v-if="items.length !== 0">
              <div v-if="log && index < maxEntityNumber"
                   v-on:click="goToPath(getFunctionName(log))"
                   class="hover-enabled h-c-blue mb-0">
                <div v-for="(world, index2) in getFunctionName(log).title"  :key="index2" class="d-inline">
                  <div :class="index2 === 0 ? 'ml-4 d-inline' : 'd-inline'">
                    {{index2 === 0 ? $tc(world.option, world.num) : $tc(world.option, world.num).toLowerCase()}}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="items.length === 0" class="ml-4">
              {{$tc('info.noLogsInLast')}} {{rangeDays}} {{$tc('message.day', 2).toLocaleLowerCase()}}
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { concat, orderBy, filter, isNil } from 'lodash'
import { DateTime } from 'luxon'

export default {
  name: 'Home',
  data () {
    return {
      DateTime,
      originalItems: [],
      user: {},
      isDefaultAdmin: false,
      maxEntityNumber: 5,
      rangeDays: 7,
      items: []
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      const user = Vue.getLocalStorage('session').user
      const username = user.userName
      this.user = user
      this.isDefaultAdmin = user.config && user.config.adminDefault && user.config.adminDefault === 'true'

      const start = parseInt(DateTime.local().plus({ days: -this.rangeDays }).toMillis() / 1000)
      const end = parseInt(DateTime.local().toMillis() / 1000)
      this.$root.$emit('activeLoader', true)
      const path = `/application_logs?user=${username}&start=${start}&end=${end}`

      this.getAllLogs(path).then(logs => {
        const items = orderBy(filter(logs, o => o && o.data), ['ts'], ['desc'])
        const itemsSet = new Set()

        items.forEach(item => {
          if (!isNil(item) && !isNil(item.data) && !isNil(item.data.routePath) && item.data.routePath.includes('/:id')) {
            const path = item.data.routePath
            itemsSet.add(path.replace('/:id', ''))
          } else if (!isNil(item) && !isNil(item.data) && !isNil(item.data.routePath)) {
            itemsSet.add(item.data.routePath)
          }
        })

        this.originalItems = items
        this.items = filter(Array.from(itemsSet), o => o !== '/' && o !== '/logout' && o !== '/home')
        this.$root.$emit('activeLoader', false)
      })
    },
    getAllLogs (path, page, parentLogs) {
      if (path) {
        return Vue.myGet(this, path).then(obj => {
          return this.getAllLogs(null, obj.nextPage, obj.logs).then(results => concat(parentLogs, results))
        })
      }

      if (page) {
        return Vue.myGet(this, `/application_logs?page=${page}`).then(obj => {
          return this.getAllLogs(null, obj.nextPage, obj.logs).then(results => concat(parentLogs, results))
        })
      }
      return new Promise(resolve => resolve(parentLogs))
    },
    goToPath (log) {
      this.$router.push({ name: log.name })
    },
    getFunctionName (log) {
      return Vue.findRouteObjByPath(log)
    }
  }
}
</script>

<style scoped>
.home-image {
  height: 100%;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  padding: 0;
  margin: 0;
  background: url('../../static/dimetior_home.jpg') no-repeat center;
  background-size: cover;
}
</style>
